import baustein from "baustein";
import { BREAKPOINTS } from "web/react/constants";
import analytics from "web/script/analytics/analytics";
import globals from "web/script/modules/globals";
import { getLanguageWithoutCountry } from "web/script/modules/language";
import { addVisibilityWatcher } from "web/script/modules/visibility-watcher";
import googleCsa from "web/script/embedded/google-adsense";
import onAdLoaded, { trackKevelEvent } from "web/script/utils/ad-analytics";
import browser from "web/script/utils/browser";

const shoppingUnitMap = {
    feed: {
        mobile: { styleId: "6493972874", numberOfProducts: 11 },
        smalltablet: { styleId: "9304817232", numberOfProducts: 3 },
        tablet: { styleId: "8443912564", numberOfProducts: 3 },
        bigtablet: { styleId: "2062292250", numberOfProducts: 3 },
        netbook: { styleId: "3067548115", numberOfProducts: 4 },
        desktop: { styleId: "6244568227", numberOfProducts: 4 },
    },
    pdp: {
        mobile: { styleId: "1355743730", numberOfProducts: 11 },
        smalltablet: { styleId: "2319777103", numberOfProducts: 3 },
        tablet: { styleId: "1809475656", numberOfProducts: 4 },
        desktop: { styleId: "5047513430", numberOfProducts: 5 },
    },
    overlay: {
        desktop: { styleId: "3386270748", numberOfProducts: 5 },
    },
};

export default baustein.register("adsense-custom-search-ads", {
    init() {
        googleCsa();
    },

    onInsert() {
        this._removeVisiblityWatcher = addVisibilityWatcher(this.el, (visible) => {
            if (visible) {
                this.createCsaShoppingUnit();
                this._removeVisiblityWatcher();
            }
        });
    },

    createCsaShoppingUnit() {
        const {
            channelId,
            styleId: lystStyleId,
            keyword,
            personalizedAds,
            instance,
            clickUrl,
            impressionUrl,
        } = this.options;

        const csaContainer = this.el.querySelector(`#adsense-custom-search-ads${instance}`);

        const { styleId: googleStyleId, numberOfProducts } = getFromDeviceMap(
            shoppingUnitMap,
            lystStyleId
        );

        const pageOptions = {
            pubId: "partner-vert-pla-lyst-srp",
            styleId: googleStyleId,
            query: keyword,
            personalizedAds: personalizedAds == "True",
            channel: channelId,
            hl: getLanguageWithoutCountry(),
            adtest: isPreviewDomain() ? "on" : "off",
        };

        const afshBlock = {
            container: csaContainer.id,
            width: csaContainer.offsetWidth,
            number: numberOfProducts,
            enableInteractive: true,
            linkTarget: "_blank",
            adLoadedCallback: function(containerName, adsLoaded) {
                if (adsLoaded) {
                    try {
                        onAdLoaded(
                            csaContainer,
                            "adsense-shopping",
                            channelId,
                            {
                                personalizedAds,
                            },
                            clickUrl
                        );
                    } catch (err) {
                        analytics.event("adsense-shopping", "no_ad", channelId, true, {
                            personalizedAds,
                        });
                    }
                }
            },
        };

        googleCsa("plas", pageOptions, afshBlock);

        // send impression events
        if (impressionUrl.length > 0) {
            trackKevelEvent(impressionUrl, "false");
        }
        analytics.event("adsense-shopping", "impression", channelId, true, { personalizedAds });
    },
});

function isPreviewDomain() {
    return globals.window.location.hostname.split(".").indexOf("lystpreviews") > 0;
}

export function getFromDeviceMap(map, pagetype) {
    const deviceMap = map[pagetype];
    const windowWidth = browser.getClientWidth();

    // NB. not BREAKPOINTS.ExtraLarge, a bit bigger than that (1200px)
    if (windowWidth >= 1305) {
        // optional desktop breakpoint
        return deviceMap["desktop"];
        // NB. not BREAKPOINTS.Large, a tiny big bigger (992px)
    } else if (windowWidth >= 1021) {
        // optional netbook breakpoint - defaults to desktop
        if ("netbook" in deviceMap) {
            return deviceMap["netbook"];
        }
        return deviceMap["desktop"];
    } else if (windowWidth >= 992) {
        // optional breakpoint - defaults to desktop
        if ("bigtablet" in deviceMap) {
            return deviceMap["bigtablet"];
        }
        if ("tablet" in deviceMap) {
            return deviceMap["tablet"];
        }
        return deviceMap["desktop"];
    } else if (windowWidth >= BREAKPOINTS.Medium) {
        // optional tablet breakpoint - defaults to desktop
        if ("tablet" in deviceMap) {
            return deviceMap["tablet"];
        }
        return deviceMap["desktop"];
    } else if (windowWidth >= BREAKPOINTS.Small) {
        // optional tablet breakpoint - defaults to mobile
        if ("smalltablet" in deviceMap) {
            return deviceMap["smalltablet"];
        }
    }
    return deviceMap["mobile"];
}
